import { useState } from "react";
import React from "react";

import Modal from "@mui/material/Modal";

import { Fade } from "@mui/material";

import M1 from "../../../assets/img/manchete/manchete1.png";
import M2 from "../../../assets/img/manchete/manchete2.png";
import M3 from "../../../assets/img/manchete/manchete3.png";
import M4 from "../../../assets/img/manchete/manchete4.png";

export default function PreViz(props) {
  const [open, setOpen] = useState(true);

  let numImages = { 1: M1, 2: M2, 3: M3, 4: M4 };

  let sectionID = props.mancheteValue;

  return (
    <div>
      <Modal
        open={open}
        onClose={props.handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ overflow: "scroll" }}
        disableScrollLock={true}
      >
        <Fade in={open} timeout={500}>
          <img
            src={numImages[sectionID]}
            style={{
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
              width: "60%",
              transform: "translate(0%, 0%)",
            }}
          />
        </Fade>
      </Modal>
    </div>
  );
}
